import { Structure } from '@portal-internet/components';
import { getDynamicComponents } from 'components';
import styles from '../loading.module.scss';

const getStructure = (props) => {
    return false;
};

const SkeletonLoadingPages = (props) => {
    const structure = getStructure(props);
    const DynamicComponents = getDynamicComponents('corporatiu');
    if (!structure) return <></>;

    return (
        <div className={styles.loadingSkeleton} data-content='skeleton-loading-page'>
            <div className={styles.skeletonContent}>
                <Structure
                    {...{
                        structure,
                        dynamicComponents: DynamicComponents,
                        routerQuery: {}
                    }}
                />
            </div>
        </div>
    );
};

export default SkeletonLoadingPages;
